import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraDataTable, SpecraFilterToolbar } from '@mono/ui-components/captains';
import { SpecraText } from '@mono/ui-components/ensigns';
import { SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { formatDistanceToNow } from 'date-fns';
import { useState } from 'react';
import { useProjectConversations } from '../../../components/ProposalDashboard/v2/hooks/useProjectConversations';
import { useLayoutStore } from '../../../lib/stores/LayoutStore';
import { useRfiRecord } from './RfiRecordContext';
/** Chat history (WRT-07 page 3): the RFI project's Assist conversations; a row opens it in the Assist rail. */ export function RfiChatHistoryPage() {
    const record = useRfiRecord();
    const { data = [], isLoading } = useProjectConversations(record?.zouProjectId ?? null);
    const [search, setSearch] = useState('');
    const setAssistChatId = useLayoutStore((s)=>s.setAssistChatId);
    const setAssistOpen = useLayoutStore((s)=>s.setAssistOpen);
    const rows = data.filter((c)=>!search || c.title.toLowerCase().includes(search.toLowerCase()));
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-[var(--space-4)] p-[var(--space-6)]",
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                title: "Chat history",
                titleSize: "ui"
            }),
            /*#__PURE__*/ _jsx(SpecraFilterToolbar, {
                search: {
                    value: search,
                    onChange: (e)=>setSearch(e.target.value),
                    placeholder: 'Search conversations'
                }
            }),
            /*#__PURE__*/ _jsx(SpecraDataTable, {
                columns: [
                    {
                        id: 'title',
                        header: 'Title',
                        cell: (r)=>r.title || 'Untitled conversation'
                    },
                    {
                        id: 'updated',
                        header: 'Last activity',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraText, {
                                size: "meta",
                                tone: "muted",
                                children: formatDistanceToNow(new Date(r.updatedAt), {
                                    addSuffix: true
                                })
                            })
                    }
                ],
                emptyTitle: search ? 'No matching conversations' : 'No conversations yet',
                getRowId: (r)=>r.chatId,
                getRowLabel: (r)=>r.title || 'Conversation',
                loading: isLoading,
                onRowClick: (r)=>{
                    setAssistChatId(r.chatId);
                    setAssistOpen(true);
                },
                rows: rows,
                testId: Testids.rfiWorkspace.chatHistoryTable
            })
        ]
    });
}
